import { FETCH_SHIPMENT_FEES_DETAILS_SUCCESS, FETCH_SHIPMENT_FEES_DETAILS_FAILURE, FETCH_SHIPMENT_LABEL_FILE_REQUEST, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const ShipmentFeesDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHIPMENT_FEES_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_SHIPMENT_LABEL_FILE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_SHIPMENT_FEES_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default ShipmentFeesDetailsReducer;
